export class NewsletterManager {
    constructor(app) {
        this.app = app;
        this.formContainer = null;
        this.subscribeButton = null;
        this.emailInput = null;
        this.statusMessage = null;
        this.isVisible = false;
        
        // Create the subscription form
        this.createSubscriptionForm();
        
        // Initially hide the form
        this.hide();
    }

    createSubscriptionForm() {
        // Create main container
        this.formContainer = document.createElement('div');
        this.formContainer.className = 'newsletter-container';
        
        // Create close button
        const closeButton = document.createElement('button');
        closeButton.className = 'newsletter-close-button';
        closeButton.innerHTML = '×';
        closeButton.addEventListener('click', () => this.hide());
        
        // Create form element
        const form = document.createElement('form');
        form.className = 'newsletter-form';
        form.addEventListener('submit', (e) => this.handleSubmit(e));
        
        // Create email input
        this.emailInput = document.createElement('input');
        this.emailInput.type = 'email';
        this.emailInput.placeholder = 'enter your email';
        this.emailInput.className = 'newsletter-input';
        this.emailInput.required = true;
        
        // Create subscribe button
        this.subscribeButton = document.createElement('button');
        this.subscribeButton.type = 'submit';
        this.subscribeButton.className = 'newsletter-button';
        this.subscribeButton.textContent = 'subscribe';
        
        // Create status message container
        this.statusMessage = document.createElement('div');
        this.statusMessage.className = 'newsletter-status';
        
        // Assemble the form
        form.appendChild(this.emailInput);
        form.appendChild(this.subscribeButton);
        this.formContainer.appendChild(closeButton);
        this.formContainer.appendChild(form);
        this.formContainer.appendChild(this.statusMessage);
        
        // Add to document
        document.body.appendChild(this.formContainer);
    }

    async handleSubmit(event) {
        event.preventDefault();
        
        const email = this.emailInput.value;
        if (!this.validateEmail(email)) {
            this.showStatus('Please enter a valid email address', 'error');
            return;
        }

        try {
            this.subscribeButton.disabled = true;
            this.showStatus('Joining the KosmicKluster...', 'pending');
            
            // Send to our Mailchimp proxy endpoint
            const response = await fetch('/api/subscribe', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email })
            });

            const data = await response.json();
            
            if (response.ok) {
                this.showStatus('Welcome aboard! Check your email to confirm your spot.', 'success');
                this.emailInput.value = '';
                
                // Hide the form after successful subscription
                setTimeout(() => {
                    this.hide();
                }, 3000);
            } else {
                if (data.message.includes('already subscribed')) {
                    this.showStatus('You\'re already part of the journey!', 'info');
                    setTimeout(() => {
                        this.hide();
                    }, 3000);
                } else {
                    throw new Error(data.message || 'Failed to subscribe');
                }
            }
        } catch (error) {
            this.showStatus(error.message || 'Something went wrong. Please try again.', 'error');
        } finally {
            this.subscribeButton.disabled = false;
        }
    }

    validateEmail(email) {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
    }

    showStatus(message, type = 'info') {
        this.statusMessage.textContent = message;
        this.statusMessage.className = `newsletter-status ${type}`;
        
        // Clear error messages after 5 seconds
        if (type === 'error' || type === 'info') {
            setTimeout(() => {
                this.statusMessage.textContent = '';
                this.statusMessage.className = 'newsletter-status';
            }, 5000);
        }
    }

    show() {
        if (!this.isVisible) {
            // Recreate the form if it doesn't exist
            if (!document.body.contains(this.formContainer)) {
                this.createSubscriptionForm();
            }
            this.formContainer.classList.add('visible');
            this.isVisible = true;
        }
    }

    hide() {
        if (this.isVisible) {
            // Remove the form container from DOM entirely
            this.formContainer.remove();
            this.isVisible = false;
        }
    }

    toggle() {
        if (this.isVisible) {
            this.hide();
        } else {
            this.show();
        }
    }
}
